import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Loading placeholder for the coach's My Students list — gradient header, the
// "Students" heading, then a two-column grid of student cards.
export default function MyStudentsSkeleton({ isDarkMode }) {
    const cardCls = `rounded-2xl border p-5 ${isDarkMode ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200 shadow-sm"}`;
    const baseColor = isDarkMode ? "#334155" : "#e2e8f0";
    const highlightColor = isDarkMode ? "#475569" : "#f1f5f9";

    return (
        <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
            <div className={`min-h-screen ${isDarkMode ? "bg-surface" : "bg-surface"}`}>
                <div className="max-w-5xl mx-auto px-4 py-8">
                    <div className="mb-8"><Skeleton height={112} borderRadius={16} /></div>
                    <Skeleton width={160} height={22} className="mb-4" />
                    <div className="grid gap-4 sm:grid-cols-2">
                        {Array.from({ length: 6 }).map((_, i) => (
                            <div key={i} className={cardCls}>
                                <div className="flex items-start gap-4">
                                    <Skeleton width={48} height={48} borderRadius={12} />
                                    <div className="flex-1">
                                        <Skeleton width="55%" height={15} />
                                        <Skeleton width="75%" height={12} className="mt-1" />
                                        <div className="flex gap-3 mt-3">
                                            <Skeleton width={90} height={26} borderRadius={8} />
                                            <Skeleton width={110} height={26} borderRadius={8} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </SkeletonTheme>
    );
}
